import { ImportedInvoicesTableAccessor } from '../enums/importedInvoicesTableAccessor'

// Shoebox column set: filename, upload date and the Cegid sync tag. The
// extraction-shaped columns (invoice no / dates / contact / net total) do not
// apply to imported documents.
export const importedInvoicesTableColumns: ImportedInvoicesTableAccessor[] = [
  ImportedInvoicesTableAccessor.FileName,
  ImportedInvoicesTableAccessor.UploadDate,
  ImportedInvoicesTableAccessor.IntegrationStatus,
]
